import React from 'react';
import './SearchComp.less';
import { observer } from 'mobx-react';

interface ISearchPropType {
    prefixCls?: string;
    style?: any;
    styles?: any;
    styleMsg?: any;
    onClick?: any; // 点击事件
    data?: any;
}

const searchImg = require('../../images/search.png');

// const homeSearchImg: any = require('../../images/home_search.png');

@observer
class SearchComp extends React.Component<ISearchPropType, any> {
    static defaultProps = {
        prefixCls: 'search',
    };

    constructor(props) {
        super(props);
        this.state = {
            searchIcon: searchImg
        };
    }

    render() {
        const {prefixCls, style, onClick, data, styleMsg, styles} = this.props;
        const {searchIcon} = this.state;
        if (data.name) {
            localStorage.setItem('shopName', data.name);
        }
        let shopName = localStorage.getItem('shopName') ? localStorage.getItem('shopName') : '国孕商城的店铺';
        return (
            <div
                className={`${prefixCls}-container`}
                style={style}
                onClick={() => {
                    onClick();
                }}
            >
                <div className={`${prefixCls}-content`} style={styles}>
                    <img src={searchIcon} alt=""/>
                    <p className={`${prefixCls}-content-p`} style={styleMsg}>在<span>{shopName}</span>中搜索</p>
                </div>
            </div>
        );
    }
}

export default SearchComp;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/searchComp/SearchComp.tsx